import React, { useState } from 'react';
import { Upload, Input, Space, Select } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { useCustomData } from '../pages/context/mineCustomDataProvider';

interface PaginationProps {
    totalItems: number;
    itemsPerPage: number;
    currentPage: number;
    onPageChange: (page: number) => void;
    themeColor: string;
}

const Pagination: React.FC<PaginationProps> = ({
    totalItems,
    itemsPerPage,
    currentPage,
    onPageChange,
    themeColor
}) => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const [inputPage, setInputPage] = useState(currentPage);
    const { getValue } = useCustomData();
    const to = getValue('to');
    const page = getValue('page');
    const gapAt = getValue('gapAt');

    const handlePageChange = (newPage: number) => {
        if (newPage >= 1 && newPage <= totalPages) {
            onPageChange(newPage);
        }
    };

    const handleGoToPage = () => {
        if (inputPage >= 1 && inputPage <= totalPages) {
            onPageChange(inputPage);
        } else {
            alert("请输入有效的页码！");
        }
    };

    const renderPageNumbers = () => {
        const pageNumbers = [];

        for (let i = 1; i <= totalPages; i++) {
            if (i === 1 || i === totalPages || (i >= currentPage - 2 && i <= currentPage + 2)) {
                pageNumbers.push(
                    <div
                        key={i}
                        onClick={() => handlePageChange(i)}
                        className={`page-btn ${currentPage === i ? 'active' : ''}`}
                        style={{
                            color: currentPage === i ? themeColor : '#33364b',
                            borderColor: currentPage === i ? themeColor : '#e5e5ee'
                        }}
                    >
                        {i}
                    </div>
                );
            } else if (
                (i === currentPage - 3 && currentPage > 4) ||
                (i === currentPage + 3 && currentPage < totalPages - 3)
            ) {
                pageNumbers.push(<span key={`ellipsis-${i}`}>...</span>);
            }
        }

        return pageNumbers;
    };

    return (
        <div className="pagination">
            {currentPage === 1 ? (
                <div><LeftOutlined /></div>
            ) : (
                <div onClick={() => handlePageChange(currentPage - 1)}>
                    <LeftOutlined />
                </div>
            )}
            {renderPageNumbers()}
            {currentPage === totalPages ? (
                <div><RightOutlined /></div>
            ) : (
                <div onClick={() => handlePageChange(currentPage + 1)}>
                    <RightOutlined />
                </div>
            )}
            <span>{to}</span>
            <Input
                className="page-input"
                id="pageInput"
                type="number"
                min="1"
                max={totalPages}
                value={inputPage}
                onChange={(e) => {
                    const value = parseInt(e.target.value, 10);
                    if (!isNaN(value) && value >= 1 && value <= totalPages) {
                        setInputPage(value);
                    } else {
                        setInputPage(currentPage);
                    }
                }}
            />
            <span>{page}</span>
            <div className="page-click" onClick={handleGoToPage}>{gapAt}</div>
        </div>
    );
};

export default Pagination;